import React from 'react';
import Button from '../../components/button/Button';
import Popup from './Popup';
import { getPopupContent } from './utils';
import { usePopupContext } from '../contexts/PopupContext';
import { POPUP_NAMES } from '../../constants/popups';

const LecturaNoDetailsAvailablePopup = () => {
    const {
        actions: { hideLecturaNoDetailsAvailablePopup },
    } = usePopupContext();

    const { header, message, okButtonText } = getPopupContent(
        POPUP_NAMES.LECTURA_NO_DETAILS_AVAILABLE_POPUP,
    );

    return (
        <Popup
            cssClass="no-details-available-popup"
            header={header}
            message={message}
            buttons={[
                <Button key="ok-button" onClick={hideLecturaNoDetailsAvailablePopup}>
                    {okButtonText}
                </Button>,
            ]}
        />
    );
};

export default LecturaNoDetailsAvailablePopup;
